import React, { useEffect, useMemo } from 'react';
import { string, node, object, bool } from 'prop-types';
import svg4everybody from 'svg4everybody';
import ThemeContext from '../../context/ThemeContext.js';
import FontManager from '../FontManager/index.jsx';

/**
 * ThemeProvider component.
 */
const ThemeProvider = ({
  children,
  theme,
  iconsPublicPath,
  iconsEmbedManifest,
  embedIcons,
  tokens,
  adobeFontsId,
  adobeFontsCssEmbed
}) => {
  useEffect(() => {
    svg4everybody();
  }, []);
  const contextValue = useMemo(() => ({
    theme,
    iconsPublicPath,
    iconsEmbedManifest,
    embedIcons,
    tokens
  }), [theme, iconsPublicPath, iconsEmbedManifest, embedIcons, tokens]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, adobeFontsId && /*#__PURE__*/React.createElement(FontManager, {
    adobeFontsId: adobeFontsId,
    cssEmbed: adobeFontsCssEmbed
  }), /*#__PURE__*/React.createElement(ThemeContext.Provider, {
    value: contextValue
  }, children));
};
ThemeProvider.defaultProps = {
  iconsPublicPath: '/',
  iconsEmbedManifest: null,
  embedIcons: false,
  tokens: null,
  adobeFontsId: null,
  adobeFontsCssEmbed: false
};
ThemeProvider.propTypes = process.env.NODE_ENV !== "production" ? {
  /** The child components to be themed. */
  children: node.isRequired,
  /** The name of a theme present in the themes package. */
  theme: string.isRequired,
  /** The design tokens manifest for the theme. */
  tokens: object,
  /** The public path to our icons. */
  iconsPublicPath: string,
  /** A manifest containing the embedded icons for a theme. */
  iconsEmbedManifest: object,
  /** Embed the icons in all cases. */
  embedIcons: bool,
  /** An Adobe Fonts ID. */
  adobeFontsId: string,
  /** Use CSS embed mode for our fonts (by default this is false). */
  adobeFontsCssEmbed: bool
} : {};
export default ThemeProvider;